"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
var EMPTY_MAP = {};
function getNodes(node) {
    var states = node.states;
    var nodes = Object.keys(states).reduce(function (accNodes, stateKey) {
        var subState = states[stateKey];
        var subNodes = getNodes(states[stateKey]);
        accNodes.push.apply(accNodes, [subState].concat(subNodes));
        return accNodes;
    }, []);
    return nodes;
}
exports.getNodes = getNodes;
function getTransitionStateKeys(transition) {
    if (typeof transition === 'string') {
        return [transition];
    }
    return Object.keys(transition);
}
function getEdges(node, visited) {
    if (visited === void 0) { visited = {}; }
    var states = node.states;
    visited[node.key] = true;
    var subNodeEdges = Object.keys(states).reduce(function (_edges, key) {
        if (visited[key]) {
            return _edges;
        }
        var subState = states[key];
        _edges.push.apply(_edges, getEdges(subState, visited));
        visited[key] = true;
        return _edges;
    }, []);
    if (!node.on) {
        return subNodeEdges;
    }
    var edges = Object.keys(node.on).reduce(function (accEdges, event) {
        if (!node.on || !node.parent) {
            return accEdges;
        }
        var parent = node.parent;
        var transition = node.on[event];
        if (!transition) {
            return accEdges;
        }
        var subStateKeys = getTransitionStateKeys(transition);
        subStateKeys.forEach(function (subStateKey) {
            var subNode = parent.getState(subStateKey);
            var edge = { event: event, source: node, target: subNode };
            accEdges.push(edge);
            if (!visited[subStateKey]) {
                accEdges.push.apply(accEdges, getEdges(subNode, visited));
                visited[subStateKey] = true;
            }
        });
        return accEdges;
    }, []);
    return subNodeEdges.concat(edges);
}
exports.getEdges = getEdges;
function getAdjacencyMap(node) {
    var adjacency = {};
    var events = node.events;
    function findAdjacencies(stateValue) {
        var stateKey = JSON.stringify(stateValue);
        if (adjacency[stateKey]) {
            return;
        }
        adjacency[stateKey] = {};
        for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
            var event_1 = events_1[_i];
            var nextState = node.transition(stateValue, event_1);
            adjacency[stateKey][event_1] = { state: nextState.value };
            findAdjacencies(nextState.value);
        }
    }
    findAdjacencies(node.initialState.value);
    return adjacency;
}
exports.getAdjacencyMap = getAdjacencyMap;
function getShortestPaths(machine) {
    if (!machine.states) {
        return EMPTY_MAP;
    }
    var adjacency = getAdjacencyMap(machine);
    var initialStateId = JSON.stringify(machine.initialState.value);
    var pathMap = (_a = {},
        _a[initialStateId] = [],
        _a);
    var visited = new Set();
    function util(stateValue) {
        var stateId = JSON.stringify(stateValue);
        visited.add(stateId);
        var eventMap = adjacency[stateId];
        for (var _i = 0, _a = Object.keys(eventMap); _i < _a.length; _i++) {
            var event_2 = _a[_i];
            var nextStateValue = eventMap[event_2].state;
            if (!nextStateValue) {
                continue;
            }
            var nextStateId = JSON.stringify(utils_1.toTrie(nextStateValue));
            if (!pathMap[nextStateId] ||
                pathMap[nextStateId].length > pathMap[stateId].length + 1) {
                pathMap[nextStateId] = (pathMap[stateId] || []).concat([
                    { state: stateValue, event: event_2 }
                ]);
            }
        }
        for (var _b = 0, _c = Object.keys(eventMap); _b < _c.length; _b++) {
            var event_3 = _c[_b];
            var nextStateValue = eventMap[event_3].state;
            if (!nextStateValue) {
                continue;
            }
            var nextStateId = JSON.stringify(nextStateValue);
            if (visited.has(nextStateId)) {
                continue;
            }
            util(nextStateValue);
        }
        return pathMap;
    }
    util(machine.initialState.value);
    return pathMap;
    var _a;
}
exports.getShortestPaths = getShortestPaths;
function getShortestPathsAsArray(machine) {
    var result = getShortestPaths(machine);
    return Object.keys(result).map(function (key) { return ({
        state: JSON.parse(key),
        path: result[key]
    }); });
}
exports.getShortestPathsAsArray = getShortestPathsAsArray;
function getSimplePaths(machine) {
    if (!machine.states) {
        return EMPTY_MAP;
    }
    var adjacency = getAdjacencyMap(machine);
    var visited = new Set();
    var path = [];
    var paths = {};
    function util(fromPathId, toPathId) {
        visited.add(fromPathId);
        if (fromPathId === toPathId) {
            paths[toPathId] = paths[toPathId] || [];
            paths[toPathId].push(path.slice());
        }
        else {
            for (var _i = 0, _a = Object.keys(adjacency[fromPathId]); _i < _a.length; _i++) {
                var subEvent = _a[_i];
                var nextStateValue = adjacency[fromPathId][subEvent].state;
                if (!nextStateValue) {
                    continue;
                }
                var nextStateId = JSON.stringify(nextStateValue);
                if (!visited.has(nextStateId)) {
                    path.push({ state: JSON.parse(fromPathId), event: subEvent });
                    util(nextStateId, toPathId);
                }
            }
        }
        path.pop();
        visited.delete(fromPathId);
    }
    var initialStateId = JSON.stringify(machine.initialState.value);
    Object.keys(adjacency).forEach(function (nextStateId) {
        util(initialStateId, nextStateId);
    });
    return paths;
}
exports.getSimplePaths = getSimplePaths;
function getSimplePathsAsArray(machine) {
    var result = getSimplePaths(machine);
    return Object.keys(result).map(function (key) { return ({
        state: JSON.parse(key),
        paths: result[key]
    }); });
}
exports.getSimplePathsAsArray = getSimplePathsAsArray;



//////////////////
// WEBPACK FOOTER
// ./~/xstate/lib/graph.js
// module id = 1318
// module chunks = 168707334958949